module.exports = __webpack_public_path__ + "img/weixin.4c42a5c9.png";